import { ODataSelect } from "@iconics/core";
import { UserType } from "../../../../Providers.StaticData/StaticDataProvider";

export class IdentityProvider extends ODataSelect
{
    public Id = 0;
    public SecurityProviderTypeId = 0;
    public Name = '';
    public IsDefault = false;
}

export class User extends ODataSelect
{
    public Id = '';
    public Email = '';
    public IdentityProviderId = 0;
    public UserType: UserType = 'User';
    public ApplicationKey: string | null = '';
    public PreferredName: string | null = '';
    public UserInitials: string | null = '';
    public FirstName: string | null = '';
    public LastName: string | null = '';
    public DisplayName: string | null = '';
    public UserLocation: string | null = '';
    public PhoneNumber: string | null = '';
    public UserPreferences: string | null = '';
    public ['@odata.etag']: string = '';

    public toSelect(): string
    {
        return '';
    }
}

export class UserRoleData extends ODataSelect
{
    public Id = '';
    public Name = '';
    public IsOwner = '';
}

export interface IRoleData
{
    Id: string;
    Name: string;
    IdentityProviderName: string;
    SecurityProviderTypeName: string;
    Active: string;
    IsOwner: number;
    Configurable: string;
}

export interface IPostUserResponse
{
    Id: string;
    ApplicationKey?: string;
}
